import classNames from 'classnames'
import type { JSX } from 'react'

import styles from './AlertIconWrapper.module.scss'

interface AlertIconWrapperProps {
  children: React.ReactNode
  isActive?: boolean
  spaced?: boolean
  gapped?: boolean
  asElement?: boolean
  fullWidth?: boolean
  className?: string
  success?: boolean
  ref?: React.Ref<HTMLDivElement>
}

export const AlertIconWrapper = (props: AlertIconWrapperProps): JSX.Element => {
  const {
    children,
    ref,
    asElement,
    gapped,
    isActive,
    spaced,
    className,
    fullWidth,
    success,
    ...rest
  } = props

  return (
    <div
      {...rest}
      ref={ref}
      className={classNames(styles.alertIconWrapper, className, {
        [styles.active]: isActive && !asElement,
        [styles.spaced]: spaced,
        [styles.fullWidth]: fullWidth,
        [styles.gapped]: gapped,
        [styles.activeElement]: isActive && asElement,
        [styles.asElement]: asElement,
        [styles.success]: success,
      })}
    >
      <span
        className={classNames(styles.children, {
          [styles.fullWidth]: fullWidth,
        })}
      >
        {children}
      </span>
      <div
        className={classNames(styles.iconContainer, {
          [styles.active]: isActive && asElement,
        })}
      >
        <div className={styles.icon} />
      </div>
    </div>
  )
}
